import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanActivateChild, Route, RouterStateSnapshot } from '@angular/router';
import { ConfigService } from '../Services/ConfigService';
import { AuthService } from './auth.service';

@Injectable()
export class RoleAuthGuard implements CanActivate, CanActivateChild {

	constructor(public configData: ConfigService, private authService: AuthService) { }

	canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
		return this.roleDecide(route);
	}

	canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
		return this.roleDecide(route);
	}

	roleDecide(route: Route | ActivatedRouteSnapshot): boolean {
		if (!this.authService.isAuthenticated()) {
			this.authService.login();
			return false;
		}
		var allowedRoles: string[] = [];
		if (route?.data?.allowedRoles) {
			allowedRoles = route.data.allowedRoles;
		}
		if (!allowedRoles.length) {
			return true;
		}
		for (let role of allowedRoles) {
			if (this.configData.IsUserInRole(role)) {
				return true;
			}
		}

		//this.configData.goHome();
		return false;
	}
}
